import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import FAQ from './faq';

function FAQIndex({ match }: InferProps<typeof FAQIndex.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}`} component={FAQ} />
    </Switch>
  );
}

FAQIndex.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default FAQIndex;
